import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import searchIcon from './../../../../assets/onboard-images/Search_Icon.png';
import { useHistory } from 'react-router-dom';
import AdminBreadcrumb from '../../../../components/Administration/General/Admin-breadcrumb';
import { OnboardSelect } from '../../../../components/Onboard/OnboardComponents/Dropdown/Select';
import { getAquaaAdminAccountsData, getAquaaAdminAccountsTableData, updateAquaaAdminAccountsDataStart } from '../../../../actions/Applications/aquaa.action';

const AquaaAdminAccounts = () => {
   const dispatch = useDispatch();
   const history = useHistory()
   const aquaaAdminAccountsData = useSelector((state) => state.aquaaReducer.aquaaAdminAccountsData);
   const aquaaAdminAccountsTableData = useSelector((state) => state.aquaaReducer.aquaaAdminAccountsTableData);
 
  const [isRefreshClicked, setIsRefreshedClicked] = useState(false); 
    const [selectedAccount, setSelectedAccount] = useState();
     const [filter, setFilter] = useState('');
          let searchColumns = ['account_Name'];

   useEffect(()=> {
           dispatch(getAquaaAdminAccountsData());
           dispatch(getAquaaAdminAccountsTableData());
          
         }, [dispatch]);

           const columns = aquaaAdminAccountsTableData && aquaaAdminAccountsTableData.length > 0 ? Object.keys(aquaaAdminAccountsTableData[0]) : [];

const data = aquaaAdminAccountsTableData

function searchRows(rows) {
    return rows.filter((row) =>
      searchColumns.some(
        (column) =>
          row[column]
            .toString()
            .toLowerCase()
            .indexOf(filter.toLowerCase()) > -1,
      ),
    );
  }

  const AddAccountHandler = () =>{
 dispatch(updateAquaaAdminAccountsDataStart([{"Account":selectedAccount}]));
 dispatch(getAquaaAdminAccountsTableData());
 setSelectedAccount('');
 setIsRefreshedClicked(true)
  dispatch(getAquaaAdminAccountsTableData());

  }
         console.log('aquaaAdminAccountsTableData',aquaaAdminAccountsTableData)
  return (
     <section>
    <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={true} value2={() => history.push('/aquaaapplications')} label2='AQuAA' isActive3={true}
        value3={() => history.push('/aquaaadminonboardlanding')} label3='AQuAA Admin' isActive4={false} label4='Accounts'/>
      <section className="App_Layout" style={{ marginBottom: '20px' }}>
        <div className="Applications_Title"> Accounts </div>
      </section>
         <section className='App_Layout'>
       <main className='Title_bar'>
       <main className='Aquaa_dropdown'>
                  <label HtmlFor='country'>Account</label>
                  <OnboardSelect data={aquaaAdminAccountsData} name='accountname' value='accountname' id='RoleId' marginTop='10px'
                    editValue='' addValueToQueue= {(name, value) => { setSelectedAccount(value); setIsRefreshedClicked(false) }} refresh={isRefreshClicked} />
                </main>
       <div className='btn_adduser' onClick={()=>AddAccountHandler()}>Add</div>
       </main>
      
      </section>
        <div> <span className='search_bar_AdminFlow'>
                                         <input className='search_input_AdminFlow' value={filter || ''} onChange={e => setFilter(e.target.value)} placeholder='Search Account' />
                                         <button className='search_icon_AdminFlow'><img src={searchIcon} alt='' /> </button>
                                       </span></div>
      <br/> <br/> 
     <table className="aquaa-table">
  <thead>
    <tr>
      {columns.map((col, index) => (
        <th key={index}>{col}</th>
      ))}
    </tr>
  </thead>
  <tbody>
    {data && data.length > 0 ? (
      searchRows(data).map((row, rowIndex) => (
        <tr key={rowIndex}>
          {columns.map((col, colIndex) => {
            const cellData = row[col]; // row['account_Name']
            return <td key={colIndex}>{cellData}</td>;
          })}
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={columns.length}>
          <section>
            <div className="noData-para" style={{ marginTop: 0 }}>
              <div style={{ marginTop: 30 }}>
                No data available, please try different filters or contact the admin
              </div>
            </div>
          </section>
        </td>
      </tr>
    )}
  </tbody>
</table>

      </section>
  )
}

export default AquaaAdminAccounts